const DESPACHOS_HARDCODED_YPF = [
  {
    idDespacho: 486003,
    manguera: 19,
    producto: "NAFTA SUPER",
    surtidor: "5",
    litros: 14.7275,
    importe: 20000,
    hora: "2025-07-03T16:46:08.637",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "5A19",
  },
  {
    idDespacho: 486000,
    manguera: 15,
    producto: "INFINIA DIESEL",
    surtidor: "4",
    litros: 7.3638,
    importe: 11000,
    hora: "2025-07-03T16:42:52.813",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B15",
  },
  {
    idDespacho: 485992,
    manguera: 15,
    producto: "NAFTA SUPER",
    surtidor: "4",
    litros: 7.5847,
    importe: 10300,
    hora: "2025-07-03T16:36:49.54",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B15",
  },
  {
    idDespacho: 485989,
    manguera: 23,
    producto: "NAFTA INFINIA",
    surtidor: "6",
    litros: 1.5449,
    importe: 2098,
    hora: "2025-07-03T16:33:45.057",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "6B23",
  },
  {
    idDespacho: 485988,
    manguera: 13,
    producto: "D-500",
    surtidor: "4",
    litros: 5,
    importe: 6760,
    hora: "2025-07-03T16:33:07.71",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 294,
    precio: 1352,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B13",
  },
  {
    idDespacho: 485986,
    manguera: 15,
    producto: "NAFTA SUPER",
    surtidor: "4",
    litros: 7.3638,
    importe: 10000,
    hora: "2025-07-03T16:31:58.137",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B15",
  },
  {
    idDespacho: 485985,
    manguera: 24,
    producto: "NAFTA INFINIA",
    surtidor: "6",
    litros: 39.7647,
    importe: 62033,
    hora: "2025-07-03T16:31:09.137",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 292,
    precio: 1560,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "6B24",
  },
  {
    idDespacho: 485982,
    manguera: 23,
    producto: "NAFTA SUPER",
    surtidor: "6",
    litros: 1.4728,
    importe: 2000,
    hora: "2025-07-03T16:26:05.627",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "6B23",
  },
  {
    idDespacho: 485978,
    manguera: 11,
    producto: "NAFTA SUPER",
    surtidor: "3",
    litros: 7.3638,
    importe: 10000,
    hora: "2025-07-03T16:22:31.263",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "3A11",
  },
  {
    idDespacho: 485977,
    manguera: 1,
    producto: "D-500",
    surtidor: "1",
    litros: 36.9822,
    importe: 50000,
    hora: "2025-07-03T16:20:57.237",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 294,
    precio: 1352,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "1A1",
  },
  {
    idDespacho: 485973,
    manguera: 7,
    producto: "NAFTA SUPER",
    surtidor: "2",
    litros: 6.6274,
    importe: 9000,
    hora: "2025-07-03T16:17:02.53",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 293,
    precio: 1358,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "2B7",
  },
];

const DESPACHOS_HARDCODED_SHELL = [
  {
    idDespacho: 1534892,
    manguera: 12,
    producto: "SHELL EVOLUX DIESEL B 500",
    surtidor: "3",
    litros: 20.9205,
    importe: 30000,
    hora: "2025-07-17T08:09:43.327",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10458,
    precio: 1434,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "3A12",
  },
  {
    idDespacho: 1534886,
    manguera: 22,
    producto: "FORM SHELL SUPER              ",
    surtidor: "6",
    litros: 10.453,
    importe: 15000,
    hora: "2025-07-17T08:02:20.31",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10495,
    precio: 1435,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "6B22",
  },
  {
    idDespacho: 1534866,
    manguera: 3,
    producto: "V-POWER  DIESEL",
    surtidor: "1",
    litros: 18.7735,
    importe: 30000,
    hora: "2025-07-17T07:31:13.727",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10499,
    precio: 1598,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "1A3",
  },
  {
    idDespacho: 1534853,
    manguera: 14,
    producto: "FORM SHELL SUPER              ",
    surtidor: "4",
    litros: 2.7902,
    importe: 4004,
    hora: "2025-07-17T06:49:29.427",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10495,
    precio: 1435,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B14",
  },
  {
    idDespacho: 1534862,
    manguera: 16,
    producto: "SHELL EVOLUX DIESEL B 500",
    surtidor: "4",
    litros: 13.9498,
    importe: 20004,
    hora: "2025-07-17T07:12:54.51",
    descripcionEstado: "Disponible",
    estado: " ",
    idArticulo: 10458,
    precio: 1434,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B16",
  },
  {
    idDespacho: 1534903,
    manguera: 14,
    producto: "FORM SHELL SUPER              ",
    surtidor: "4",
    litros: 4.878,
    importe: 7000,
    hora: "2025-07-17T08:42:41.347",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10495,
    precio: 1435,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B14",
  },
  {
    idDespacho: 1534897,
    manguera: 13,
    producto: "V-POWER  NAFTA BIO         ",
    surtidor: "4",
    litros: 6.0132,
    importe: 10000,
    hora: "2025-07-17T08:28:02.17",
    descripcionEstado: "Disponible",
    estado: "\u0000",
    idArticulo: 10564,
    precio: 1663,
    empleado: "",
    idEmpleado: null,
    idMangueraCS: "4B13",
  },
];
const obtenerPorPuesto = async idPuesto => {
  const bandera = localStorage.getItem("bandera");

  return {
    data: {
      combustibles: bandera === "ypf" ? DESPACHOS_HARDCODED_YPF : DESPACHOS_HARDCODED_SHELL,
    },
    status: 200,
    statusText: "OK",
  };
};

const combustible = {
  obtenerPorPuesto,
};

export default combustible;
